import { CircleDot, Dribbble, Shield, Snowflake, Swords, Target, Trophy, Volleyball, Radio, Flag, Ticket, Rocket, Disc } from "lucide-react";

const MAP = {
  soccer: Volleyball,
  rugby: Shield,
  tennis: CircleDot,
  basketball: Dribbble,
  "american-football": Trophy,
  baseball: Target,
  "ice-hockey": Snowflake,
  mma: Swords,
  live: Radio,
  "horse-racing": Flag,
  lotto: Ticket,
  crash: Rocket,
  "aussie-rules": Disc,
};

export const SportIcon = ({ sport, className = "h-4 w-4" }) => {
  const I = MAP[sport] || Trophy;
  return <I className={className} />;
};
